module.exports = __webpack_public_path__ + "img/wild.2e8f48fd.png";